import { CommonHeaders } from './commonHeaders';

export class ProductHeaders extends CommonHeaders {
  public constructor(apiKey: string) {
    super(apiKey);

    this.set('X-Fox-ApiKey', apiKey);
    this.set('X-Fox-Api-Request-ID', '{uuid}');
    this.set('X-Fox-Client', '{client}');
    this.set('X-Fox-DMA', '{dma}');
    this.set('X-Fox-Home-DMA', '{home_dma}');
    this.set('X-Fox-Home-Zipcode', '{home_zip_code}');
    this.set('X-Fox-UserAuth', 'Bearer {accessToken}');
    this.set('X-Fox-Zipcode', '{zip_code}');
  }
}
